<div class="notification-bell-wrapper px-2 relative">

  <!-- Bell button — mesma aparência do announcekit -->
  <button
    (click)="togglePanel()"
    class="relative flex items-center justify-center"
    aria-label="Notificações de arquivos">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
      stroke="currentColor" class="text-gray-400 hover:text-hs-active size-6">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
    </svg>

    @if (unreadLabel()) {
    <span
      class="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-blue-600 text-white text-[10px] font-bold leading-none">
      {{ unreadLabel() }}
    </span>
    }
  </button>

  <!-- Dropdown panel -->
  @if (isOpen()) {
  <div
    class="absolute right-0 top-10 w-80 bg-white rounded-xl shadow-xl border border-gray-100 z-50 overflow-hidden">

    <div class="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
      <span class="text-sm font-semibold text-gray-800">Notificações</span>
      @if (fileNotificationService.unreadCount() > 0) {
      <button
        (click)="markAllAsViewed()"
        class="text-xs text-blue-600 font-medium hover:text-blue-800 transition-colors">
        Marcar todas como lidas
      </button>
      }
    </div>

    <div class="max-h-80 overflow-y-auto">

      @if (loading()) {
      <div class="flex items-center justify-center py-8">
        <div class="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
      } @else if (notifications().length === 0) {
      <div class="flex flex-col items-center justify-center py-8 px-4 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor" class="w-8 h-8 text-gray-300 mb-2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
        </svg>
        <p class="text-sm text-gray-400">Nenhuma notificação</p>
      </div>
      } @else {
      @for (notification of notifications(); track notification.id) {
      <button
        (click)="onNotificationClick(notification)"
        class="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0 flex items-start gap-3"
        [class.bg-blue-50]="!notification.viewed">

        <!-- Thumbnail -->
        <div class="flex-shrink-0 w-10 h-10 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
          @switch (fileIcon(notification)) {
            @case ('image') {
              <img [src]="notification.fileUrl" [alt]="notification.fileName"
                class="w-full h-full object-cover" (error)="onThumbnailError($event)">
            }
            @case ('video') {
              <video [src]="notification.fileUrl" class="w-full h-full object-cover"></video>
            }
            @case ('pdf') {
              <img src="assets/pdf.png" class="w-7 h-7 object-contain">
            }
            @case ('zip') {
              <img src="assets/zip.png" class="w-7 h-7 object-contain">
            }
            @default {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-5 h-5 text-gray-400">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
              </svg>
            }
          }
        </div>

        <div class="flex-1 min-w-0">
          <div class="flex items-start gap-2">
            <p class="text-sm font-medium text-gray-800 truncate flex-1">{{ notification.fileName }}</p>
            @if (!notification.viewed) {
            <span class="flex-shrink-0 mt-1 w-2 h-2 rounded-full bg-blue-500"></span>
            }
          </div>
          <p class="text-xs text-gray-400 truncate mt-0.5">
            {{ fileNotificationService.folderPath(notification) }}
          </p>
          <p class="text-xs text-gray-400 mt-1">{{ formatDate(notification.createdAt) }}</p>
        </div>
      </button>
      }
      }

    </div>
  </div>
  }

</div>
